import {
  Box,
  Button,
  Grid2,
  Grow,
  Stack,
  Typography,
} from "@mui/material";
import React, {  useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { grey, red } from "@mui/material/colors";
import ClaimPairsByDay from "../components/ClaimPairsByDay";
import ShowMoreButtons from "../components/ShowMoreButtons";

function DetailsPage() {
  const { claim_id } = useParams(); // Extract claim_id from the route parameters

  const location = useLocation();
  const state = location.state || {}; // Provide a default empty object if location.state is null
  const { item, back_link } = state;
  
  

  const incrementValue = 8;
  const [itemsToShow, setItemsToShow] = useState(incrementValue); // Number of items to show initially

  const handleShowMore = () => {
    setItemsToShow((prevItems) => prevItems + incrementValue); // Show N more items
  };

  const handleShowAll = () => {
    setItemsToShow(item.similar_comparisons_list.length);
  };

  const handleReset = () => {
    setItemsToShow(incrementValue); // Show all items
  };
  // Check if location.state exists and has item
  // const item = location.state ? location.state : null;
  if (!item) {
    // Handle the case where item is not available
    return (
      <Box>
        <Typography variant="h6">No Claim Details Available</Typography>
      </Box>
    );
  }

  // const thresholds = Object.entries(item.total_tasks.new_mail_to_new_mail);


  return (
    <Grow in={true}>
      <Box
        sx={{
          m: 2,
          mt: 10,
          p: 0,
          border: 5,
          borderRadius: 3,
          borderColor: "lightgray",
          display: "flex", // Use flexbox for layout
          flexDirection: "column", // Arrange children vertically
          height: "89vh", // Set a fixed height for the container
          overflowY: "auto", // Make the container scrollable
        }}
      >
        <Grid2
          container
          sx={{
            bgcolor: "lightgray",
            borderBottom: 3,
            borderColor: "secondary.main",
            py: 0,
            position: "sticky",
            zIndex: 2,
            width: "100%",
            top: 0, // Ensure it sticks to the top
            pb: 1,
            p: 1,
            alignItems: "center",
          }}
        >
          <Grid2
            size="grow"
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <Button
              component={Link}
              to={back_link}
              variant="contained"
              sx={{
                height: 40,
                borderRadius: 3,
                textTransform: "unset",
                backgroundColor: red[800],
              }}
              startIcon={<ArrowBackIosIcon />}
            >
              BACK
            </Button>
          </Grid2>
          <Grid2
            sx={{
              display: "flex",
              alignItems: "center",
              color: "secondary.main",
            }}
          >
            <Stack spacing={0}>
              <Stack
                direction={"row"}
                spacing={1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography sx={{ fontWeight: "bold", fontSize: 26 }}>
                  {claim_id}
                </Typography>

                <Typography
                  sx={{
                    textTransform: "capitalize",

                    fontSize: 16,
                  }}
                >
                  [{item.type_of_claim}]
                </Typography>
              </Stack>
              <Stack
                direction={"row"}
                spacing={1}
                sx={{
                  justifyContent: "center",
                  // bgcolor: "lightgray",
                  mx: 2,
                  mt: 0,

                  py: 0.5,
                  color: "secondary.main",
                  fontWeight: "bold",
                }}
              >
                <Typography sx={{ fontWeight: "light", fontSize: 14 }}>
                  {item.num_qualifying_pairs} Qualifying Comparisons
                </Typography>

                <Typography>{" \u2022 "}</Typography>
                <Typography sx={{ fontWeight: "light", fontSize: 14 }}>
                  {item.similar_comparisons_list.length} Similar Comparisons
                </Typography>
              </Stack>
            </Stack>
          </Grid2>
          <Grid2 size="grow"></Grid2>
        </Grid2>
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
          <ClaimPairsByDay
            similar_comparisons_list={item.similar_comparisons_list}
            itemsToShow={itemsToShow}
            claim_id={claim_id}
            item={item}
          />
        </Box>
        <Grid2
          container
          sx={{
            bgcolor: "lightgray",
            borderTop: 3,
            borderColor: "secondary.main",
            height: 50,
            position: "sticky",
            zIndex: 2,
            bottom: 0, // Ensure it sticks to the bottom
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 1,
          }}
        >
          <Grid2 size="grow" sx={{ border: 0 }}>
            <Typography
              variant="h5"
              sx={{
                color: grey[800],
                border: 0,
                display: "flex",
                justifyContent: "right",
                alignItems: "right",
                px: 1,
              }}
            >
              Showing{" "}
              {itemsToShow > item.similar_comparisons_list.length
                ? item.similar_comparisons_list.length
                : itemsToShow}{" "}
              out of {item.similar_comparisons_list.length} Similar Comparisons
            </Typography>
          </Grid2>
          <Grid2>
            <ShowMoreButtons
              itemsToShow={itemsToShow}
              incrementValue={incrementValue}
              details_by_day_length={item.similar_comparisons_list.length}
              handleShowAll={handleShowAll}
              handleShowMore={handleShowMore}
              handleReset={handleReset}
            />
          </Grid2>
          <Grid2 size="grow" />
        </Grid2>
      </Box>
    </Grow>
  );
}

export default DetailsPage;
